



















































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { LiveChatUser } from "@scrile/api-provider/dist/api/LivechatsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIconButton from "@/components/BaseIconButton";
import BaseInput from "@/components/BaseInput";
import CustomScroll from "@/components/CustomScroll";
import ListItem from "@/components/ListItem";
import PageTitle from "@/components/PageTitle";
import LiveChatUserAvatar from "../LiveChatUserAvatar";
import MuteController from "../MuteController";

export default defineComponent({
  name: "ViewersList",
  components: {
    LiveChatUserAvatar,
    MuteController,
    BaseIconButton,
    CustomScroll,
    BaseAvatar,
    ListItem,
    BaseInput,
    PageTitle,
  },
  props: {
    userList: { type: Array as PropType<LiveChatUser[]>, required: true },
    isOwner: { type: Boolean, required: true },
    moderatorIds: { type: Array as PropType<string[]>, default: () => [] },
    streamingUserIds: { type: Array as PropType<string[]>, default: () => [] },
  },
  emits: ["close"],
  setup(props) {
    const { authUser } = useAuthUser();
    const term = ref("");
    const filterLoading = ref(false);

    const filteredUserList = computed<LiveChatUser[]>(() =>
      props.userList.filter(user => {
        if (!term.value.trim()) return true;
        return user.user?.screenName.includes(term.value);
      })
    );
    const setTerm = async (termValue: string) => {
      term.value = termValue;
    };

    const canUpdateUser = (viewer: LiveChatUser) => {
      return (
        props.isOwner ||
        viewer.referrerId === authUser.value?.id ||
        (authUser.value &&
          props.moderatorIds.includes(authUser.value.id) &&
          !props.streamingUserIds.includes(viewer.userId))
      );
    };

    return {
      term,
      filterLoading,
      filteredUserList,
      canUpdateUser,
      setTerm,
    };
  },
});
